import script from "./h5Custom.vue?vue&type=script&setup=true&lang=ts"
export * from "./h5Custom.vue?vue&type=script&setup=true&lang=ts"

import "./h5Custom.vue?vue&type=style&index=0&id=7969ab17&lang=less"

const __exports__ = script;

export default __exports__